<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div class="container-fluid">
    <div class="row">
      <!-- ───────────── Main column ───────────── -->
      <div [ngClass]="task?.property ? 'col-xl-8' : 'col-12'">
        <div class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-start flex-wrap gap-2">
            <div *ngIf="task">
              <h4 class="card-title mb-1">
                <span class="task-code me-2">{{ task.task_id }}</span>{{ task.title }}
              </h4>
              <span class="badge" [ngClass]="statusClass(task.status)">{{ task.status }}</span>
              <span *ngIf="task.verified_at" class="badge bg-info ms-1">Verified</span>
              <span *ngIf="task.is_overdue" class="badge bg-danger ms-1">Overdue {{ overdueDays(task) }}d</span>
            </div>
            <div class="d-flex flex-wrap gap-1" *ngIf="task">
              <button class="btn btn-secondary btn-sm" (click)="backToTasks()"><i class="bi bi-arrow-left me-1"></i> Back</button>
              <button *ngIf="canUpdate" class="btn btn-outline-primary btn-sm" (click)="edit()">Edit</button>
              <button *ngIf="canAssign" class="btn btn-outline-primary btn-sm" (click)="openReassign()">Reassign</button>
              <div class="dropdown" *ngIf="canUpdate">
                <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">Change status</button>
                <ul class="dropdown-menu">
                  <li *ngFor="let s of statuses">
                    <a class="dropdown-item" [class.active]="s === task.status" href="javascript:void(0)" (click)="changeStatus(s)">{{ s }}</a>
                  </li>
                </ul>
              </div>
              <button *ngIf="canAssign && isDone && !task.verified_at" class="btn btn-primary btn-sm" (click)="verify()">Mark verified</button>
              <button *ngIf="canDelete" class="btn btn-outline-danger btn-sm" (click)="deleteTask()">Delete</button>
            </div>
          </div>

          <div class="card-body" *ngIf="task">
            <div class="detail-row">
              <div class="dl">Type</div>
              <div class="dd">{{ task.task_type || task.category || '—' }}</div>
            </div>
            <div class="detail-row">
              <div class="dl">Linked to</div>
              <div class="dd">
                <ng-container *ngIf="task.property">
                  Property <a [routerLink]="['/admin/properties/property-view', task.property.id, 1]">{{ task.property.name }}</a>
                  <span class="text-muted" *ngIf="task.property.address"> · {{ task.property.address }}</span>
                </ng-container>
                <ng-container *ngIf="!task.property && task.related">
                  {{ relatedTypeLabel(task.related.type) }}
                  <a *ngIf="task.related.type === 'lead'" [routerLink]="['/admin/leads/view', task.related.id]">{{ task.related.name }}</a>
                  <span *ngIf="task.related.type !== 'lead'">{{ task.related.name }}</span>
                </ng-container>
                <span *ngIf="task.client_type" class="badge bg-light text-dark ms-2">{{ task.client_type }}</span>
                <span *ngIf="!task.property && !task.related">—</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="dl">Assigned to</div>
              <div class="dd">
                <ng-container *ngIf="assignee; else noAssignee">
                  <span class="avatar">{{ initials(assignee.name) }}</span>{{ assignee.name }}
                  <span class="text-muted" *ngIf="assignee.role_identifier"> ({{ assignee.role_identifier | titlecase }})</span>
                </ng-container>
                <ng-template #noAssignee>—</ng-template>
              </div>
            </div>
            <div class="detail-row">
              <div class="dl">Due</div>
              <div class="dd">
                <span *ngIf="task.due_date">{{ task.due_date | date: 'EEE d MMM yyyy' }}</span>
                <span *ngIf="!task.due_date">—</span>
                <span *ngIf="plannedWindow()">, {{ plannedWindow() }}</span>
                <span class="badge ms-2" [ngClass]="priorityClass(task.priority)">{{ task.priority }}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="dl">Created by</div>
              <div class="dd">{{ task.created_by || '—' }} · {{ task.created_at | date: 'EEE d MMM yyyy' }}</div>
            </div>
            <div class="detail-row" *ngIf="task.description">
              <div class="dl">Description</div>
              <div class="dd"><p class="task-description">{{ task.description }}</p></div>
            </div>
            <div class="detail-row" *ngIf="task.location_text">
              <div class="dl">Location</div>
              <div class="dd">{{ task.location_text }}</div>
            </div>
            <div class="detail-row" *ngIf="task.hold_reason && task.status === 'On Hold'">
              <div class="dl">Hold reason</div>
              <div class="dd">{{ task.hold_reason }}</div>
            </div>
            <div class="detail-row" *ngIf="task.outcome">
              <div class="dl">Outcome</div>
              <div class="dd">
                {{ task.outcome }}
                <span class="text-muted" *ngIf="task.completed_by"> · by {{ task.completed_by }}</span>
                <span class="text-muted" *ngIf="task.completed_at"> · {{ task.completed_at | date: 'd MMM yyyy HH:mm' }}</span>
              </div>
            </div>
            <div class="detail-row" *ngIf="task.completion_note">
              <div class="dl">Completion note</div>
              <div class="dd"><p class="task-description">{{ task.completion_note }}</p></div>
            </div>
            <div class="detail-row" *ngIf="task.verified_at">
              <div class="dl">Verified</div>
              <div class="dd">{{ task.verified_by || '—' }} · {{ task.verified_at | date: 'd MMM yyyy HH:mm' }}</div>
            </div>

            <!-- Checklist -->
            <div class="mt-4 checklist">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">Checklist {{ checklistDone }} / {{ checklist.length }}</h5>
                <div *ngIf="canUpdate">
                  <button *ngIf="!editingChecklist" class="btn btn-link btn-sm" (click)="startEditChecklist()">Edit</button>
                  <ng-container *ngIf="editingChecklist">
                    <button class="btn btn-primary btn-sm me-1" (click)="saveChecklist()" [disabled]="loadingService.isLoading()">Save</button>
                    <button class="btn btn-secondary btn-sm" (click)="cancelEditChecklist()">Cancel</button>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="!editingChecklist">
                <div class="form-check" *ngFor="let item of checklist" [class.done]="item.is_done">
                  <input class="form-check-input" type="checkbox" [id]="'chk-' + item.id" [checked]="item.is_done"
                    [disabled]="!canUpdate" (change)="toggleItem(item)" />
                  <label class="form-check-label" [for]="'chk-' + item.id">
                    {{ item.label }}
                    <small class="text-muted" *ngIf="item.is_done && item.done_by"> · {{ item.done_by }}</small>
                  </label>
                </div>
                <p class="text-muted small mb-0" *ngIf="checklist.length === 0">No checklist items.</p>
              </ng-container>
              <ng-container *ngIf="editingChecklist">
                <div class="input-group input-group-sm mb-1" *ngFor="let item of checklistDraft; let i = index">
                  <input type="text" class="form-control" [(ngModel)]="item.label" />
                  <button class="btn btn-outline-danger" type="button" (click)="removeDraftItem(i)"><i class="fa fa-times"></i></button>
                </div>
                <div class="input-group input-group-sm mt-2">
                  <input type="text" class="form-control" placeholder="Add a checklist item" [(ngModel)]="newChecklistLabel"
                    (keydown.enter)="$event.preventDefault(); addDraftItem()" />
                  <button class="btn btn-outline-primary" type="button" (click)="addDraftItem()">Add</button>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="card-body text-center py-5" *ngIf="!task && !loadingService.isLoading()">
            <p>No task details available</p>
          </div>
        </div>

        <!-- Tabs -->
        <div class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <ul class="nav nav-tabs card-header-tabs">
              <li class="nav-item" *ngIf="canViewComments">
                <a class="nav-link" [class.active]="activeTab === 'comments'" (click)="setActiveTab('comments')" role="button">Comments ({{ comments.length }})</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'attachments'" (click)="setActiveTab('attachments')" role="button">Attachments ({{ sortedUploads.length }})</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'history'" (click)="setActiveTab('history')" role="button">History ({{ history.length }})</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'activity'" (click)="setActiveTab('activity')" role="button">Activity ({{ activity.length }})</a>
              </li>
            </ul>
            <button *ngIf="canAddComments && activeTab === 'comments'" class="btn btn-primary btn-sm"
              (click)="openCommentDrawer()" [disabled]="loadingService.isLoading()">
              <i class="bi bi-plus-circle me-1"></i> Add Comment
            </button>
          </div>
          <div class="card-body">
            <!-- Comments -->
            <div *ngIf="activeTab === 'comments' && canViewComments">
              <div class="table-responsive" *ngIf="comments.length > 0">
                <table class="table">
                  <thead><tr><th>Date</th><th>Added By</th><th>Comment</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let comment of comments">
                      <td>{{ comment.created_at | date: 'dd-MM-yyyy HH:mm' }}</td>
                      <td>{{ comment.created_by }}</td>
                      <td [innerHTML]="comment.comment"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center py-4" *ngIf="comments.length === 0"><p>No comments available</p></div>
            </div>

            <!-- Attachments -->
            <div *ngIf="activeTab === 'attachments'">
              <ul class="list-group" *ngIf="sortedUploads.length > 0">
                <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let file of sortedUploads">
                  <div class="d-flex align-items-center gap-2">
                    <a *ngIf="isImage(file)" [href]="file.upload_key" target="_blank" rel="noopener">
                      <img class="photo-thumb" [src]="file.upload_key" [alt]="file.original_name" />
                    </a>
                    <div>
                      <a [href]="file.upload_key" target="_blank" rel="noopener">{{ file.original_name || 'Attachment' }}</a>
                      <span *ngIf="file.kind === 'completion_photo'" class="badge bg-success ms-2">Completion photo</span>
                    </div>
                  </div>
                  <span class="badge bg-light text-dark" *ngIf="file.created_at">{{ file.created_at | date: 'dd-MM-yyyy' }}</span>
                </li>
              </ul>
              <div class="text-center py-4" *ngIf="sortedUploads.length === 0"><p>No attachments</p></div>
            </div>

            <!-- History -->
            <div *ngIf="activeTab === 'history'">
              <div class="table-responsive" *ngIf="history.length > 0">
                <table class="table">
                  <thead><tr><th>Date</th><th>Field</th><th>Previous Value</th><th>New Value</th><th>Changed By</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let item of history">
                      <td>{{ item.changed_at | date: 'dd-MM-yyyy HH:mm' }}</td>
                      <td class="text-capitalize">{{ relatedTypeLabel(item.field) }}</td>
                      <td>{{ item.previous_value || '-' }}</td>
                      <td>{{ item.new_value }}</td>
                      <td>{{ item.changed_by || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center py-4" *ngIf="history.length === 0"><p>No history available</p></div>
            </div>

            <!-- Activity -->
            <div *ngIf="activeTab === 'activity'">
              <ul class="timeline" *ngIf="activity.length > 0">
                <li *ngFor="let a of activity">
                  <div>
                    <span class="time me-2">{{ a.started_at | date: 'd MMM HH:mm' }}<ng-container *ngIf="a.ended_at"> – {{ a.ended_at | date: 'HH:mm' }}</ng-container></span>
                    <strong>{{ activityLabel(a) }}</strong>
                    <span class="text-muted" *ngIf="a.user?.name"> · {{ a.user?.name }}</span>
                    <span class="badge bg-light text-dark ms-1" *ngIf="a.duration_min">{{ a.duration_min }} min</span>
                    <span class="badge bg-warning text-dark ms-1" *ngIf="!a.ended_at">Check-out pending</span>
                  </div>
                  <div class="small text-muted" *ngIf="a.location_text || a.accuracy_m">
                    {{ a.location_text }}<span *ngIf="a.accuracy_m"> · GPS ±{{ a.accuracy_m }} m</span>
                  </div>
                  <div class="small" *ngIf="a.remarks">{{ a.remarks }}</div>
                </li>
              </ul>
              <div class="text-center py-4" *ngIf="activity.length === 0"><p>No activity logged yet</p></div>
            </div>
          </div>
        </div>
      </div>

      <!-- ───────────── Right column ───────────── -->
      <div class="col-xl-4" *ngIf="task?.property">
        <div class="card">
          <div class="card-header"><h5 class="card-title mb-0">Other tasks on this property</h5></div>
          <div class="card-body">
            <div class="other-task py-2" *ngFor="let t of otherTasks">
              <a [routerLink]="['/admin/tasks/view', t.id]"><span class="task-code me-1">{{ t.task_id }}</span>{{ t.title }}</a>
              <span class="badge ms-1" [ngClass]="statusClass(t.status)">{{ t.status }}</span>
              <div class="small text-muted">
                {{ (t.assignee || t.owner)?.name || '—' }}<span *ngIf="t.due_date"> · {{ t.due_date | date: 'd MMM' }}</span>
              </div>
            </div>
            <p class="text-muted small mb-0" *ngIf="otherTasks.length === 0">No other tasks on this property.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-task-form #taskForm (saved)="onSaved()"></app-task-form>

<!-- Comment Drawer -->
<div class="offcanvas offcanvas-end customeoff" tabindex="-1" id="commentDrawer" aria-labelledby="commentDrawerLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="commentDrawerLabel">Add Comment</h5>
    <button type="button" class="btn-close" (click)="closeCommentDrawer()" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <form [formGroup]="commentForm" (ngSubmit)="saveComment()">
      <div class="mb-3">
        <label class="form-label">Comment <span class="text-danger">*</span></label>
        <ckeditor [editor]="Editor" formControlName="comment"
          [config]="{ toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList'] }"></ckeditor>
        <div class="text-danger mt-1" *ngIf="commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched">
          Comment is required
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary me-2" (click)="closeCommentDrawer()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="commentForm.invalid || loadingService.isLoading()">Save Comment</button>
      </div>
    </form>
  </div>
</div>

<!-- Hold reason prompt -->
<ng-template #holdReasonModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Put task on hold</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <label class="form-label">Reason <span class="text-danger">*</span></label>
    <textarea class="form-control" rows="3" [(ngModel)]="holdReason" placeholder="Why is this task on hold?"></textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary btn-sm" [disabled]="!holdReason.trim()" (click)="modal.close(holdReason)">Put on hold</button>
  </div>
</ng-template>

<!-- Reassign prompt -->
<ng-template #reassignModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Reassign task</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <label class="form-label">Assignee</label>
    <ng-select [items]="assignees.items" bindValue="value" bindLabel="label" placeholder="Select assignee" class="select2"
      [(ngModel)]="reassignTo" [typeahead]="assignees.search$" [virtualScroll]="true" (scrollToEnd)="assignees.scrollEnd()"
      [clearable]="false" appendTo="body"></ng-select>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary btn-sm" [disabled]="!reassignTo" (click)="modal.close(reassignTo)">Reassign</button>
  </div>
</ng-template>
